var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-container",attrs:{"role":"status"}},[_c('span',{staticClass:"loading-plaque"},[_c('img',{staticClass:"loading-indicator",attrs:{"src":_vm.loaderImageSrc,"alt":"Loading"}}),_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }